import { Group, Stack, useMantineTheme } from '@mantine/core';
import { IconCalendar, IconCheck, IconDatabase, IconList, IconNumber, IconTextSize } from '@tabler/icons-react';
import { EvidenceFieldRow } from 'components/tables/data/evidence-field/types';
import P2Regular from 'components/typography/P2Regular';
import P4Regular from 'components/typography/P4Regular';

const NAME_MAP: Record<string, string> = {
  text: 'Text',
  number: 'Číslo',
  date: 'Dátum',
  select: 'Výber',
  predefined: 'Preddefinované údaje',
  checkbox: 'Zaškrtávacie pole',
};

/**
 * Icon component for different field types.
 */
function TypeIcon({ fieldType }: { fieldType: string }) {
  const theme = useMantineTheme();

  switch (fieldType) {
    case 'text':
      return <IconTextSize size={16} color={theme.colors.red[8]} />;
    case 'number':
      return <IconNumber size={16} color={theme.colors.blue[8]} />;
    case 'date':
      return <IconCalendar size={16} color={theme.colors.green[8]} />;
    case 'select':
      return <IconList size={16} color={theme.colors.orange[8]} />;
    case 'predefined':
      return <IconDatabase size={16} color={theme.colors.violet[8]} />;
    case 'checkbox':
      return <IconCheck size={16} color={theme.colors.teal[8]} />;
    default:
      return null;
  }
}

/**
 * Column for the evidence field type.
 */
export default function FieldTypeColumn({ data: { fieldType, precision } }: { data: EvidenceFieldRow }) {
  const fieldTypeName = NAME_MAP[fieldType] || 'Neznámy typ';

  return (
    <Stack spacing={0}>
      <Group spacing={4} noWrap align="center">
        <TypeIcon fieldType={fieldType} />
        <P2Regular c="gray.8">{fieldTypeName}</P2Regular>
      </Group>
      {fieldType === 'number' && <P4Regular color="gray.6">Počet desatinných miest: {precision || 0}</P4Regular>}
    </Stack>
  );
}
